import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_MODAL_STAGES,
  coursePauseModalStageSelector,
  setCoursePauseManageModalStage,
  setSelectedSuperBatch,
  setSelectedSbatLecture,
} from 'features/courseResume';
import CoursePauseModalStageRenderer from '../CoursePauseModalStageRenderer';
import styles from './CoursePauseModal.module.scss';

function CoursePauseModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(coursePauseModalStageSelector);
  const isModalOpen = modalStage !== COURSE_PAUSE_MODAL_STAGES.notOpen;

  const handleClose = useCallback(() => {
    batch(() => {
      dispatch(setSelectedSuperBatch(null));
      dispatch(setSelectedSbatLecture(null));
      dispatch(
        setCoursePauseManageModalStage(COURSE_PAUSE_MODAL_STAGES.notOpen)
      );
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      className={styles.root}
      unMountOnClose
      onClose={handleClose}
      withoutHeader
    >
      <CoursePauseModalStageRenderer />
    </Modal>
  );
}

export default CoursePauseModal;
